import React from "react";
// import Progress from "../Progress";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import CancelButton from "../Buttons/CancelButton";
import BackButton from "../Buttons/BackButton";
import Check from "../../assets/images/Check.svg";

export const NZCitizen = ({ handleNext, handleCancel, handleBack }) => {
  return (
    <>
      <div className="intro no-min-height">
        {/* <Progress progress={40} /> */}
        <h1 className="intro-title-mi" lang="mi-NZ">
          Kōrero mai ko wai koe
        </h1>
        <hr />
        <h1 className="intro-title">Tell us who you are</h1>

        <div className="step-container">
          <h2 className="step-title mb-2">
            Do you have a New Zealand citizenship certificate?
          </h2>
          <p className="mb-4">
            You'll need your citizenship certificate number.
          </p>
          <p className="mb-4">
            If you became a NZ citizen before 1 January 2004, or were aged 12
            years or under at the time, you may need to provide an identity
            referee. We'll contact you if this is required.
          </p>
        </div>
        <div className="step-button-container">
          <SubmitButton text={"Yes"} onClick={handleNext} Icon={Check} ariaLabel="Yes - enter Citizenship details" />
          <CancelButton text={"No"} onClick={handleCancel} ariaLabel="No - enter details when you arrived in New Zealand" />
          <BackButton text={"Back"} onClick={handleBack} />
        </div>
      </div>
    </>
  );
};

export default NZCitizen;
